import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: number | null = null as any;

const selectedSesionStateSlice = createSlice({
	name: 'selectedSesionState',
	initialState,
	reducers: {
		setSelectedSesionState: (state, action: PayloadAction<number | null>) => {
			return action.payload;
		},
		resetSelectedSesionState: () => {
			return initialState;
		}
	}
});

export const { setSelectedSesionState, resetSelectedSesionState } = selectedSesionStateSlice.actions;

export default selectedSesionStateSlice.reducer;
